import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { MFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { Checkbox as CheckboxCore } from '../checkbox/Checkbox';
import { SelectBox } from '../selectbox/SelectBox';
import { isBoolean } from 'lodash-es';
import { DATA_FILTER_INPUT } from '../common/data';

export type FilterChexkboxOwnProps = {
  checkedLabel?: string;
  uncheckedLabel?: string;
  allowNullValue?: boolean;
};

export type CheckboxProps = MFieldProps<
  React.ComponentProps<typeof CheckboxCore>
> &
  FilterFieldProps &
  FilterChexkboxOwnProps;
export const FilterCheckbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      // @ts-ignore
      label,
      onChange: customOnChange,
      disabled,
      size,
      checkedLabel,
      uncheckedLabel,
      filterType,
      allowNullValue,
      ...other
    },
    ref
  ) => {
    const getValue = (value: boolean | undefined) => {
      return isBoolean(value)
        ? value.toString()
        : allowNullValue
        ? 'undefined'
        : 'false';
    };
    const realSize =
      size ||
      Math.max(
        checkedLabel?.length || 3,
        uncheckedLabel?.length || 3,
        allowNullValue ? 8 : 3
      );

    const checkedItem = { id: 'true', name: checkedLabel || 'Ano' };
    const uncheckedItem = { id: 'false', name: uncheckedLabel || 'Ne' };
    const nullItem = { id: 'undefined', name: 'Nezáleží' };

    const items = React.useMemo(
      () => [...(allowNullValue ? [nullItem] : []), checkedItem, uncheckedItem],
      [checkedLabel, uncheckedLabel, allowNullValue]
    );

    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
      >
        <Field<boolean, HTMLElement, boolean>
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (val?: string) => {
                let realVal: boolean | undefined;
                if (val === 'true') {
                  realVal = true;
                } else if (val === 'false' || !allowNullValue) {
                  realVal = false;
                } else {
                  realVal = undefined;
                }
                onChange({ target: { name, value: realVal } });
                customOnChange?.(realVal as any);
              },
              [customOnChange, onChange, name, allowNullValue]
            );

            // @ts-ignore
            let selectBoxValue = getValue(value);
            // if (allowNullValue) {
            //   console.log('selectBoxValue', selectBoxValue, value);
            // }

            return (
              <SelectBox
                {...DATA_FILTER_INPUT(name)}
                // @ts-ignore
                ref={ref}
                inputProps={{
                  size: realSize,
                }}
                className={inputClassName}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                onChange={handleChange}
                onBlur={() => {}}
                value={selectBoxValue}
                useIdAsValue
                items={items}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
